export enum Regions {
  Moscow = 1,
  Spb = 2,
  MoscowArea = 4593,
  SpbArea = 4588,
  MoscowAndArea = -1,
  SpbAndArea = -2,
}

export const EXPANSION_REGION_DISABLE_COOKIE = 'expansible_region_disable';
